import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyBkyXoeIgnyGp997fafJk8aW01AcwkycT0",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "web-developer-portfolio-d5917.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "web-developer-portfolio-d5917",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "web-developer-portfolio-d5917.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "121954357486",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:121954357486:web:1b944cd57e1dcb16b5a3ff",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-NYWTDTBST7"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const analytics = typeof window !== 'undefined' ? getAnalytics(app) : null;

export default app;